<template>
  <div class="mobile_view">
    <div class="right-content">
      <quiz-overview></quiz-overview>
    </div>
    <div class="left-content">
      <div class="quiz-content">
        <h2>Do you or your family, have a history of any of the following?</h2>
      </div>

      <ol>
        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Diabetes', 'diabetes')"
              :class="[history.diabetes.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/diabetes.png`)" />
            </span>
            <span class="option">Diabetes</span>
          </button>
        </li>

        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Heart Disease e.g. Stroke or heart attacks', 'cardiac')"
              :class="[history.cardiac.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/strokeorheartdisease.png`) " />
            </span>
            <span class="option">Heart Disease e.g. Stroke or heart attacks</span>
          </button>
        </li>

        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Cancer', 'cancer')"
              :class="[history.cancer.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/cancer.png`) " />
            </span>
            <span class="option">Cancer</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Gastrointestinal conditions', 'gastrointestinal')"
              :class="[history.gastrointestinal.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/gastrodisorders.png`) " />
            </span>
            <span class="option">Gastrointestinal conditions</span>
          </button>
        </li>

        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Allergies', 'AllergiesAndHeartdisease')"
              :class="[history.AllergiesAndHeartdisease.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/parasites.png`) " />
            </span>
            <span class="option">Allergies</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal history_button"
              @click="showModal('Asthma', 'asthma')"
              :class="[history.asthma.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/asthma.png`) " />
            </span>
            <span class="option">Asthma</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal"
              @click="showModal('Coeliac disease', 'coeliac')"
              :class="[history.coeliac.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/boweldisease.png`) " />
            </span>
            <span class="option">Coeliac disease</span>
          </button>
        </li>
        <li>
          <button
              class="option-normal history_button"
              @click="selectNone"
              :class="[history.none.selected ? 'option-selected' : '']"
          >
            <span class="image">
              <img :src=" require(`../assets/icons/noneofthese.png`) " />
            </span>
            <span class="option">None</span>
          </button>
        </li>
      </ol>

      <div class="button-content">
        <button class="btn-prev w-btn us-btn-style_2" @click="prevQuiz">
          <span class="w-btn-label">&larr; Prev</span>
        </button>
        <button
            class="btn-next w-btn us-btn-style_1"
            :class="[buttonActive ? 'btn-active' : '']"
            :disabled="!buttonActive"
            @click="nextQuiz">
          <span class="w-btn-label">Next &rarr;</span>
        </button>
      </div>
      <modals-container @saveHistory="saveInfo" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import QuizHistoryModal from "./QuizHistoryModal.vue";
import QuizOverview from "./QuizOverview.vue";
import swal from "sweetalert";
import modalContents from "../data/modal-contents.json";

export default {
  name: "QuizHistory",
  components: {
    QuizOverview,
  },
  data() {
    return {
      history: {
        diabetes: {
          selected: false,
          desc: "Diabetes",
          detail: ""
        },
        cardiac: {
          selected: false,
          desc: "Heart Disease e.g. Stroke or heart attacks",
          detail: ""
        },
        cancer: {
          selected: false,
          desc: "Cancer",
          detail: ""
        },
        gastrointestinal: {
          selected: false,
          desc: "Gastrointestinal conditions",
          detail: ""
        },
        AllergiesAndHeartdisease: {
          selected: false,
          desc: "Allergies",
          detail: ""
        },
        asthma: {
          selected: false,
          desc: "Asthma",
          detail: ""
        },
        coeliac: {
          selected: false,
          desc: "Coeliac disease",
          detail: ""
        },
        none: {
          selected: false,
          desc: "None – Family History"
        }
      }
    };
  },

  created: function() {
    let oldHistory = this.getHistory;
    let newHistory = this.history;
    let historyKeys = Object.keys( oldHistory );

    if ( historyKeys.length > 0 ) {
      historyKeys.forEach( function( hKey ) {
        newHistory[ hKey ] = oldHistory[ hKey ];
      } );
    }

    this.history = newHistory;
  },

  computed: {
    ...mapGetters( ["getHealthIssue", "getDiscuss", "getHistory", "getAge", "getGender"] ),

    buttonActive() {
      let flag = false;
      Object.keys( this.history ).forEach( key => {
        if ( this.history[ key ].selected === true ) {
          flag = true;
        }
      } );
      return flag;
    }


  },

  methods: {
    ...mapMutations( ["setStep", "setHistory", "setCostInputed"] ),

    prevQuiz() {
      this.setStep( 2 );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    nextQuiz() {
      let flag = false;
      Object.keys( this.history ).forEach( key => {
        if ( this.history[ key ].selected === true ) {
          flag = true;
        }
      } );
      if ( ! flag ) {
        swal( "Warning!", "Please select at least one option.", "warning" );
        return;
      }

      this.setStep( 4 );
      this.setHistory( this.history );
      const $form = document.getElementById( 'form' );
      $form.scrollIntoView();
    },

    selectNone() {
      Object.keys( this.history ).forEach( key => {
        if ( key !== "none" ) {
          this.history[ key ].selected = false;
        }
      } );

      this.history[ "none" ].selected = ! this.history[ "none" ].selected;

      this.setCostInputed( 4 );
      this.setHistory( this.history );
    },

    showModal( text, type ) {
      if ( this.history[ type ].selected === false ) {
        this.$modal.show(
            QuizHistoryModal,
            {
              text,
              type,
              content: modalContents.history[ type ]
            },
            {
              height: "auto",
              adaptive: true
            }
        );
      } else {
        this.history[ type ].selected = false;
        this.history[ type ].detail = "";
      }
    },

    saveInfo( data ) {
      this.history.none.selected = false;

      let selected = 0;

      Object.keys( this.history ).forEach( key => {
        if ( this.history[ key ].selected === true && key !== "none" ) {
          selected ++;
        }
      } );

      Object.keys( this.getDiscuss ).forEach( key => {
        if ( this.getDiscuss[ key ].selected === true && key !== "none" ) {
          selected ++;
        }
      } );

      Object.keys( this.getHealthIssue ).forEach( key => {
        if ( this.getHealthIssue[ key ].selected === true && key !== "none" ) {
          selected ++;
        }
      } );

      if ( selected >= 2 ) {
        swal(
            "Info",
            "You may only choose a maximum of 2 Supplementary Screenings at one Health Screening. If you wish to add more please notify the clinic and we can try to accommodate your needs.",
            "info"
        );

        return;
      }

      this.history[ data.type ].selected = true;
      this.history[ data.type ].detail = data.info;

      this.setCostInputed( 4 );
      this.setHistory( this.history );
    }
  }
};
</script>